





















































































































































































































































import {
  Department,
  Employee,
  Forms,
  SatisfactionSurveyQuestion,
  SatisfactionSurveyQuestions,
} from "@/api";
import { Component, Ref, Vue } from "vue-property-decorator";
import { requiredString, noSpace } from "@/tool/validation";
import { VForm } from "@/common/vuetify_types";
import { selfData } from "@/common/role_utils";
import ConfirmationModule from "@/components/confirmationModule/ConfirmationModule.vue";
import PublishDialog from "../PublishDialog.vue";
import draggable from "vuedraggable";
import _ from "lodash";

@Component({
  components: {
    ConfirmationModule,
    draggable,
    PublishDialog,
  },
})
export default class Question extends Vue {
  @Ref("form") readonly form!: VForm;
  formModel = false;
  departmentID = 0;
  employee = 0;
  question = "";
  title = "";
  subTitle = "";
  allowComments = false;
  allowFeedback = false;
  loading = true;
  companyId = selfData().companyId;
  required_text = [requiredString, noSpace];
  selectEditingQuestion: SatisfactionSurveyQuestion | null = null;
  saving = false;
  deleting = false;
  deleteDialog = false;
  confirmPublish = false;
  publishing = false;
  savingDraft = false;
  isEdit = false;

  required_select = (v: string) =>
    (v !== "" && v !== undefined && v != "0") || "Required";

  async created() {
    const formId = this.$route.params.formId;
    this.loading = true;
    if (formId)
      await this.$store.dispatch("survey/fetchQuestions", {
        formId,
        dispatchType: "satisfaction",
      });

    this.$store.dispatch("directory/loadAllEmployees");
    this.loading = false;
  }

  get departments(): Department[] {
    return this.$store.getters["company/departments"]?.map(
      (item: Department) => {
        return {
          ...item,
          header: undefined,
        };
      },
    );
  }

  clearForm() {
    this.selectEditingQuestion = null;
    this.departmentID = 0;
    this.question = "";
    this.allowComments = false;
    this.allowFeedback = false;
    this.isEdit = false;
    this.title = "";
    this.subTitle = "";
    this.form.reset();
    this.form.resetValidation();
  }

  get questions(): SatisfactionSurveyQuestions {
    return this.$store.getters["survey/satisfactionQuestions"];
  }

  set questions(values: SatisfactionSurveyQuestions) {
    const requestBody = values.map((item, index) => {
      return {
        ...item,
        order: index,
      };
    });

    const formId = Number(this.$route.params.formId);
    if (!formId) {
      this.$store.dispatch("alert/warning", "failed to add question");
      return;
    }
    this.$store.dispatch("survey/sortQuestion", {
      satisfactionRequestBody: requestBody,
      formId,
      dispatchType: "satisfaction",
    });
  }

  async submit() {
    const formId = Number(this.$route.params.formId);
    if (!formId) {
      this.$store.dispatch("alert/warning", "failed to add question");
      return;
    }
    if (this.form.validate()) {
      this.saving = true;
      const requestBody = {
        question: this.question,
        allowComment: this.allowComments,
        title: this.title,
        subTitle: this.subTitle,
        departmentID: this.departmentID,
        assignee: this.employee,
      };

      await this.$store.dispatch("survey/addQuestion", {
        requestBody,
        satisfactionRequestBody: requestBody,
        formId,
        dispatchType: "satisfaction",
      });
      this.saving = false;
      this.clearForm();
    }
  }

  async update() {
    debugger;
    const formId = Number(this.$route.params.formId);
    if (!formId) {
      this.$store.dispatch("alert/warning", "failed to update question");
      return;
    }
    if (this.form.validate()) {
      this.saving = true;
      const requestBody = {
        id: this.selectEditingQuestion?.id,
        question: this.question,
        allowComment: this.allowComments,
        title: this.title,
        subTitle: this.subTitle,
        departmentID: this.departmentID,
        assignee: this.employee,
      };

      await this.$store.dispatch("survey/updateQuestion", {
        satisfactionRequestBody: requestBody,
        formId,
        dispatchType: "satisfaction",
      });
      this.saving = false;
      this.clearForm();
    }
  }

  editQuestion(question: SatisfactionSurveyQuestion) {
    this.question = question.question;
    this.title = question.title || "";
    this.subTitle = question.subTitle || "";
    this.allowComments = question.allowComment || false;
    this.isEdit = true;
    this.departmentID = question.departmentId || 0;
    this.employee = question.assignee || 0;
    this.selectEditingQuestion = question;
  }

  async removeQuestion(question: SatisfactionSurveyQuestion) {
    this.selectEditingQuestion = question;
    this.deleteDialog = !this.deleteDialog;
  }

  async confirmRemove() {
    const formId = Number(this.$route.params.formId);
    if (!formId) {
      this.$store.dispatch("alert/warning", "failed to add question");
      return;
    }
    this.deleting = true;
    await this.$store.dispatch("survey/removeQuestion", {
      satisfactionRequestBody: this.selectEditingQuestion,
      formId,
      dispatchType: "satisfaction",
    });
    this.clearForm();
    this.deleting = false;
    this.deleteDialog = !this.deleteDialog;
  }

  back() {
    this.$router.back();
  }

  async publish() {
    const formId = Number(this.$route.params.formId);
    const forms = JSON.parse(
      JSON.stringify(this.$store.getters["survey/satisfactionForms"] || []),
    ) as Forms;
    const requestBody = forms.filter(form => form.id === formId);
    if (!formId || !forms || requestBody.length == 0) {
      this.$store.dispatch("alert/warning", "failed to publish form");
      return;
    }

    const form = requestBody[0];
    form.status = 3;
    this.publishing = true;
    await this.$store.dispatch("survey/updateForm", {
      satisfactionRequestBody: form,
      dispatchType: "satisfaction",
    });
    this.publishing = false;
    this.confirmPublish = !this.confirmPublish;
  }

  checkStandardQuestion(): boolean {
    if (this.selectEditingQuestion) {
      return this.selectEditingQuestion.id <= 0;
    }

    return false;
  }

  get employees(): Employee[] {
    const self = selfData();
    const empls =
      this.departmentID === 0
        ? _.orderBy(
            _.filter(
              this.$store.state.directory.employees ?? [],
              (employee: Employee) => employee.id !== self.id,
            ),
            employee => employee.firstName.toLowerCase(),
          )
        : _.orderBy(
            _.filter(
              this.$store.state.directory.employees ?? [],
              (employee: Employee) =>
                employee.id !== self.id &&
                employee.primaryDepartmentId === this.departmentID,
            ),
            employee => employee.firstName.toLowerCase(),
          );
    return empls.map((employee: Employee) => {
      return {
        ...employee,
        list: `${employee.firstName} ${employee.lastName} - ${employee.title} - ${employee.departmentAssignments[0].departmentName}`,
      };
    });
  }
}
